import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'
import { abilitiesOfProfile } from './ozpAbility'

const userData = JSON.parse(localStorage.getItem('userData'))
// the abilities follow the profile, as at the login (Login, SSOCallback) : the ones kept since the login would miss
// the menus given to a right after it (the menus of the company data, each with its own right since "Com" was split)
const existingAbility = userData ? ((userData.profile !== undefined) ? abilitiesOfProfile(userData.profile) : userData.ability) : null

export default new Ability(existingAbility || initialAbility)
